export const getSubdomain = (): string => {
  if (typeof window === 'undefined') return ''
  const hostname = window.location.hostname

  // Si es el dominio principal (innovagent.tech), no hay subdomain
  if (hostname === 'innovagent.tech' || hostname === 'www.innovagent.tech') {
    return ''
  }

  // Si tiene subdomain (ej: javier-lopez.innovagent.tech)
  const parts = hostname.split('.')
  if (parts.length >= 3 && parts[parts.length - 2] === 'innovagent' && parts[parts.length - 1] === 'tech') {
    return parts[0]
  }

  // Para desarrollo local, retornar vacío (el dashboard no depende de subdomain)
  // Las landing pages públicas sí lo necesitan, pero eso se maneja en AgentPublicPage
  return ''
}

export const isValidSubdomain = (subdomain: string): boolean => {
  return subdomain.length > 0 && /^[a-z0-9-]+$/.test(subdomain)
}

export const isMainDomain = (): boolean => {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  return hostname === 'innovagent.tech' || hostname === 'www.innovagent.tech'
}
